import SendbirdWebProviderWrapper from "@/crossPlatform/Sendbird/SendbirdWebProviderWrapper";
import type { ProvidersType } from "@/utils/providerTree.util";

/**
 * Web-specific Sendbird provider configuration
 *
 * Uses SendbirdWebProviderWrapper which handles all platform services internally.
 * This avoids importing expo-notifications on web, which would trigger console warnings.
 */
const SendbirdProviders: ProvidersType[] = [[SendbirdWebProviderWrapper, {}]];

export { SendbirdProviders };
